import React from "react";
import { Container, ContentWithPaddingXl } from "components/misc/Layouts";
import tw, { css } from "twin.macro";
import styled from "styled-components";
import { SectionHeading } from "components/misc/Headings";
import { SectionDescription } from "components/misc/Typography";
import { blogPosts } from "blogs"; // <-- comes from src/blogs/index.js
import { css as cssPropMacro } from "styled-components/macro"; //eslint-disable-line -- enables the css/tw prop in this file

const HeadingContainer = tw.div`text-center`;
const Heading = tw(SectionHeading)``;
const Description = tw(SectionDescription)`mx-auto`;

const Posts = tw.div`mt-12 flex flex-wrap -mr-3 relative`;
const Post = tw.a`flex flex-col h-full bg-gray-200 rounded overflow-hidden`;
const PostImage = styled.div(({ imageSrc }) => [
  css`background-image: url("${imageSrc || ""}");`,
  tw`h-64 sm:h-80 bg-center bg-cover`
]);
const PostText = tw.div`flex-1 px-6 py-8`;
const PostTitle = tw.h6`font-bold hover:text-primary-500 transition duration-300`;
const PostDescription = tw.p``;

const PostContainer = styled.div(({ featured }) => [
  tw`relative z-20 mt-10 sm:pt-3 pr-3 w-full sm:w-1/2 lg:w-1/3 max-w-sm mx-auto sm:max-w-none sm:mx-0`,
  featured &&
    css`
      ${tw`w-full sm:w-full lg:w-2/3`}
      ${Post} {
        ${tw`sm:flex-row items-center sm:pr-3`}
      }
      ${PostImage} {
        ${tw`sm:h-80 sm:min-h-full w-full sm:w-1/2`}
      }
      ${PostText} {
        ${tw`pl-8 pr-5`}
      }
      ${PostTitle} {
        ${tw`text-2xl mt-8`}
      }
      ${PostDescription} {
        ${tw`mt-8 mb-8 text-sm font-semibold text-gray-600 leading-relaxed`}
      }
    `
]);


export default function GridWithFeaturedPost({
  heading = "We love writing.",
  description = ""
}) {
  // show featured first, then the rest
  const posts = [...blogPosts].sort((a, b) => (b.featured === true) - (a.featured === true));

  return (
    <Container>
      <ContentWithPaddingXl>
        <HeadingContainer>
          {heading && <Heading>{heading}</Heading>}
          {description && <Description>{description}</Description>}
        </HeadingContainer>

        <Posts>
          {posts.map((post, index) => (
            <PostContainer key={post.slug || index} featured={!!post.featured}>
              <Post href={`/blog/${post.slug}`}>
                <PostImage imageSrc={post.image} />
                <PostText>
                  <PostTitle>{post.title}</PostTitle>
                  {post.featured && post.description && (
                    <PostDescription>{post.description}</PostDescription>
                  )}
                  {post.featured && (
                    <div tw="mt-6">
                      <a
                        href={`/blog/${post.slug}`}
                        tw="inline-block px-5 py-3 text-sm font-semibold text-white bg-primary-500 rounded hover:bg-primary-700 transition duration-300"
                      >
                        {post.buttonText || "Read Blog"}
                      </a>
                    </div>
                  )}
                </PostText>
              </Post>
            </PostContainer>
          ))}

        </Posts>
      </ContentWithPaddingXl>
    </Container>
  );
}